"use client"
import { useState, useEffect } from "react";

interface CountdownTimerProps {
  startDate: string;
  endDate: string;
}

const CountdownTimer = ({ startDate, endDate }: CountdownTimerProps) => {
  const [status, setStatus] = useState<string>("Loading...");
  const [colorClass, setColorClass] = useState<string>("");

  useEffect(() => {
    const interval = setInterval(() => {
      const current = new Date();
      const start = new Date(startDate);
      const end = new Date(endDate);

      // Check if event is starting soon
      if (current < start) {
        const timeDiff = start.getTime() - current.getTime();
        const hours = String(Math.floor(timeDiff / (1000 * 60 * 60))).padStart(2, "0");
        const minutes = String(Math.floor((timeDiff / (1000 * 60)) % 60)).padStart(2, "0");
        const seconds = String(Math.floor((timeDiff / 1000) % 60)).padStart(2, "0");

        setStatus(`Starts in: ${hours}:${minutes}:${seconds}`);
        setColorClass("bg-yellow-400 text-black"); // Yellow for upcoming events
      } else if (current >= start && current <= end) {
        setStatus("Live Now!");
        setColorClass("bg-green-500 text-white"); // Green for live events
      } else {
        setStatus("Event Ended");
        setColorClass("bg-red-500 text-white"); // Red for ended events
      }
    }, 1000);

    return () => clearInterval(interval); // Clean up on component unmount
  }, [startDate, endDate]);

  return (
    <div
      className={`flex items-center justify-center px-2 py-1 rounded-md text-center ${colorClass} font-semibold shadow-lg w-auto sm:px-4 sm:py-2`}
      style={{ height: "fit-content", width: "auto" }}
    >
      {status}
    </div>
  );
};

export default CountdownTimer;
